import script from "./HelpLicense.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpLicense.vue?vue&type=script&setup=true&lang=ts"

import "./HelpLicense.vue?vue&type=style&index=0&id=92ebed8c&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92ebed8c"]])

export default __exports__